import React, { useState } from "react";

import Blogsdata from "./blogsdata";
import AdminFaq from "./adminfaqs";

const BlogsTab = () => {
  const [activeTab, setActiveTab] = useState("blogs-list");

  return (
    <div style={styles.page}>
      {/* Tabs Header */}
      <div style={styles.tabs}>
        <button
          style={activeTab === "blogs-list" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("blogs-list")}
        >
          Blogs List
        </button>

        <button
          style={activeTab === "add-faq" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("add-faq")}
        >
          Add Faq
        </button>
      </div>

      {/* Content */}
      <div style={styles.tableContainer}>
        {activeTab === "blogs-list" ? <Blogsdata /> : <AdminFaq />}
      </div>
    </div>
  );
};

export default BlogsTab;

/* Inline Styles */
const styles = {
  page: {
    padding: "12px 14px",
    background: "#fff",
    fontFamily: "Arial, sans-serif",
  },

  tabs: {
    display: "flex",
    gap: "10px",
    borderBottom: "1px solid #ddd",
    marginBottom: "10px",
  },

  tab: {
    padding: "8px 14px",
    border: "1px solid #dcdcdc",
    borderBottom: "none",
    background: "#f7f7f7",
    cursor: "pointer",
    fontSize: "13px",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },

  activeTab: {
    padding: "8px 14px",
    border: "1px solid #dcdcdc",
    borderBottom: "none",
    background: "#fff",
    cursor: "pointer",
    fontSize: "13px",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
    fontWeight: "bold",
    color: "#005487",
  },

  tableContainer: {
    border: "1px solid #ddd",
    borderRadius: "6px",
    overflow: "hidden",
    background: "#fff",
  },
};